export async function requestJson<T>(
  input: RequestInfo,
  init?: RequestInit,
): Promise<{ ok: boolean; status: number; data: T | { error: string } }> {
  const res = await fetch(input, init);
  const text = await res.text();

  if (!text) {
    return {
      ok: res.ok,
      status: res.status,
      data: { error: res.ok ? "" : res.statusText },
    };
  }

  try {
    return { ok: res.ok, status: res.status, data: JSON.parse(text) as T };
  } catch {
    return {
      ok: res.ok,
      status: res.status,
      data: { error: text },
    };
  }
}

export class ApiError extends Error {
  status: number;
  payload: unknown;

  constructor(status: number, message: string, payload: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.payload = payload;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (isApiError(error)) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

export async function requestJsonOrThrow<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const result = await requestJson<T>(input, init);
  if (result.ok) {
    return result.data as T;
  }

  const message =
    typeof result.data === "object" && result.data && "error" in result.data && typeof result.data.error === "string"
      ? result.data.error
      : "Request failed";

  throw new ApiError(result.status, message, result.data);
}
